import React, { useEffect, useState, ReactNode } from 'react'
import HomepageHeader from 'shared/components/homepage-section-header'
import styled from 'styled-components'
import { IGif } from '@giphy/js-types'
import MobileArtistPreview from '../../../site/artists/list/mobile-artist-preview'
import { fetchArtistInfo } from 'shared/api/artists'

const Container = styled.div`
    margin-bottom: 20px;
`
const ScrollCarousel = styled.div`
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
    text-align: left;
    /* make sure gifs are fully visible with a scrollbar. */
    padding-bottom: 10px;
`

type Props = {
    icon?: ReactNode
}

const MobileArtistCarousel = ({ icon }: Props) => {
    const [featuredGifs, setFeaturedGifs] = useState<IGif[] | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            const featuredGifs = await fetchArtistInfo()
            setFeaturedGifs(featuredGifs)
        }

        fetchData()
        setFeaturedGifs(featuredGifs)
    }, [])

    return (
        <Container>
            <HomepageHeader seeAllLabel="All GIPHY Artists" label="Artists" url="/artists" icon={icon} />
            {featuredGifs?.length && (
                <ScrollCarousel>
                    {featuredGifs.map((gif: IGif) => (
                        <MobileArtistPreview key={gif.id} height={223} gif={gif} />
                    ))}
                </ScrollCarousel>
            )}
        </Container>
    )
}

export default MobileArtistCarousel
